<template>
  <div id="humberger_menu">
    <div @click="toggleMenu" id="menu" v-bind:class="{ menuopen: open }">
      <img
        :src="mediaportalResourceUrl + '/community/img/menu_btn.png'"
        alt="メニュー"
      />
    </div>

    <div
      id="menu_background"
      @click="toggleMenu"
      :class="{ background_open: open }"
    ></div>
    <div id="menu_list_wrapper" :class="{ list_open: open }">
      <div id="menu_list">
        <span id="menu_close_btn">
          <img
            :src="mediaportalResourceUrl + '/community/img/menu_close.png'"
            @click="toggleMenu"
            alt="閉じる"
          />
        </span>

        <div id="main_menu">
          <div>
            <a
              class="humberger_button first_menu"
              :href="communicationUrl + `/community/howto/`"
              :click="toggleMenu"
            >
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon1.png`
                  "
                  alt="結婚式準備.comとは？"
                />
              </span>
              <span class="main_menu_word">結婚式準備.comとは？</span>
            </a>

            <a
              v-if="isLogin"
              class="humberger_button"
              style="background-color: #e3055c"
              :href="communicationUrl + `/user/${userid}`"
              :click="toggleMenu"
            >
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon2.png`
                  "
                  alt="マイページ"
                />
              </span>
              <span class="main_menu_word">マイページ</span>
            </a>

            <a
              v-else
              class="humberger_button"
              style="background-color: #e3055c"
              :href="communicationUrl + `/user/sign_in`"
              :click="toggleMenu"
            >
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon2.png`
                  "
                  alt="新規会員登録・ログイン"
                />
              </span>
              <span class="main_menu_word">新規会員登録・ログイン</span>
            </a>

            <a
              class="humberger_button"
              :href="communicationUrl + `/review/`"
              :click="toggleMenu"
            >
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon3.png`
                  "
                  alt="クチコミを探す"
                />
              </span>
              <span class="main_menu_word">クチコミを探す</span>
            </a>

            <a class="humberger_button" @click="toggleDrawer(1)">
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon4.png`
                  "
                  alt="ユーザーを探す"
                />
              </span>
              <span class="main_menu_word">ユーザーを探す</span
              ><img
                v-if="!showDrawering.includes(1)"
                class="humberger-drawer"
                :src="mediaportalResourceUrl + '/community/img/drawer1_off.png'"
                alt="展開する"
              /><img
                v-else
                class="humberger-drawer"
                :src="mediaportalResourceUrl + '/community/img/drawer1_on.png'"
                alt="折りたたむ"
              />
            </a>
            <ul
              :class="{
                open_drawer: showDrawering.includes(1),
                close_drawer: !showDrawering.includes(1),
              }"
            >
              <li>
                <a
                  class="drawer-link"
                  :href="communicationUrl + `/user/`"
                  :click="toggleMenu"
                  >> Top</a
                >
              </li>
              <li>
                <a
                  class="drawer-link"
                  :href="
                    communicationUrl +
                    `/user/pre/post?s=&amp;d=&amp;ut=pre&amp;tm=review&amp;a=&amp;h=&amp;st=post`
                  "
                  :click="toggleMenu"
                  >> プレ花一覧へ</a
                >
              </li>
              <li>
                <a
                  class="drawer-link"
                  :href="
                    communicationUrl +
                    `/user/graduation/post?s=&amp;d=&amp;ut=graduation&amp;tm=review&amp;a=&amp;h=&amp;st=post`
                  "
                  :click="toggleMenu"
                  >> 卒花一覧へ</a
                >
              </li>
              <li>
                <a
                  class="drawer-link"
                  :href="
                    communicationUrl +
                    `/user/w-planner/post?s=&amp;d=&amp;ut=w-planner&amp;tm=review&amp;a=&amp;h=&amp;st=post`
                  "
                  :click="toggleMenu"
                  >> 認定プランナー一覧へ</a
                >
              </li>
            </ul>

            <a
              class="humberger_button"
              :href="communicationUrl + `/bbs/`"
              :click="toggleMenu"
            >
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon5.png`
                  "
                  alt="掲示板を探す"
                />
              </span>
              <span class="main_menu_word">掲示板を探す</span>
            </a>

            <a class="humberger_button" @click="toggleDrawer(2)">
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon6.png`
                  "
                  alt="記事を探す"
                />
              </span>
              <span class="main_menu_word">記事を探す</span
              ><img
                v-if="!showDrawering.includes(2)"
                class="humberger-drawer"
                :src="mediaportalResourceUrl + '/community/img/drawer1_off.png'"
                alt="展開する"
              /><img
                v-else
                class="humberger-drawer"
                :src="mediaportalResourceUrl + '/community/img/drawer1_on.png'"
                alt="折りたたむ"
              />
            </a>
            <ul
              :class="{
                open_drawer: showDrawering.includes(2),
                close_drawer: !showDrawering.includes(2),
              }"
            >
              <li v-for="category in categories" :key="category.id">
                <a class="drawer-link" :href="category.link"
                  >> {{ category.category_name }}</a
                >
              </li>
            </ul>

            <a
              class="humberger_button"
              :href="mediaportalUrl + '/hall/'"
              @click="toggleMenu"
            >
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon7.png`
                  "
                  alt="式場を探す"
                />
              </span>
              <span class="main_menu_word">式場を探す</span>
            </a>

            <a
              class="humberger_button"
              :href="communicationUrl + `/tag/`"
              :click="toggleMenu"
            >
              <span class="menu_icon">
                <img
                  :src="
                    mediaportalResourceUrl + `/community/img/menu_icon9.png`
                  "
                  alt="タグから探す"
                />
              </span>
              <span class="main_menu_word">タグから探す</span>
            </a>
          </div>
        </div>

        <div id="sub_menu">
          <a
            class="humberger_button"
            :href="communicationUrl + `/community/news/`"
            :click="toggleMenu"
          >
            ニュース
          </a>
          <a
            class="humberger_button"
            :href="mediaportalUrl + '/faq/'"
            @click="toggleMenu"
          >
            よくある質問
          </a>
          <a class="humberger_button sub_last" @click="toggleDrawer(3)">
            <span class="watabe">ワタベウェディンググループサイト</span>
            <img
              v-if="!showDrawering.includes(3)"
              class="drawer"
              :src="mediaportalResourceUrl + '/community/img/drawer2_off.png'"
              alt="展開する"
            />
            <img
              v-else
              class="drawer"
              :src="mediaportalResourceUrl + '/community/img/drawer2_on.png'"
              alt="折りたたむ"
            />
          </a>
          <ul
            :class="{
              open_drawer2: showDrawering.includes(3),
              close_drawer: !showDrawering.includes(3),
            }"
          >
            <li>
              <a
                class="sub_last_drawer-link"
                href="https://photowedding.okinawa/"
                @click="toggleMenu"
                >>　沖縄フォトウェディング</a
              >
            </li>
            <li>
              <a
                class="sub_last_drawer-link"
                href="https://www.ushers-photo.com/"
                @click="toggleMenu"
                >>　Users'Photo</a
              >
            </li>
          </ul>
        </div>
        <div class="contact_us">
          <a
            class="humberger_button"
            href="https://wed-junbi.com/contact/"
            @click="toggleMenu"
          >
            <li class="menu_contact">
              <p>お問い合わせ</p>
            </li>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //ハンバーガーメニューを開いているか
      open: false,
      //クリックして開いているメニュー取得し入れておく
      showDrawering: [],
      //カーソルホバーしているメニュー取得
      hoverMenu: null,
      //フクロウサイトをべた書き
      categories: [
        {
          category_name: "結婚準備",
          id: 1,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/junbi/",
        },
        {
          category_name: "費用",
          id: 2,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/cost/",
        },
        {
          category_name: "マナー",
          id: 3,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/manner/",
        },
        {
          category_name: "披露宴・演出・装飾",
          id: 4,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/reception/",
        },
        {
          category_name: "ウェディングドレス",
          id: 5,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/dress/",
        },
        {
          category_name: "美容・ヘアメイク",
          id: 6,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/beauty/",
        },
        {
          category_name: "アイテム",
          id: 7,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/item/",
        },
        {
          category_name: "トレンド",
          id: 8,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/trend/",
        },
        {
          category_name: "リゾート婚",
          id: 9,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/rizokon/",
        },
        {
          category_name: "ゲストの準備",
          id: 10,
          link: process.env.VUE_APP_BASE_MEDIAPORTAL_URL + "/guest/",
        },
        {
          category_name: "フォトウェディング",
          id: 11,
          link: "https://wed-junbi.com/photo-wedding/",
        },
        {
          category_name: "和婚",
          id: 12,
          link: "https://wed-junbi.com/wakon/",
        },
        {
          category_name: "特集",
          id: 13,
          link: "https://wed-junbi.com/special/",
        },
      ],
      //ハンバーガーメニューのメインメニューの値設定
      // loginMainMenus: [{
      //         link: "#",
      //         image_path: "menu_icon1.png",
      //         word: "結婚式準備.comとは？"
      //     },
      //     {
      //         link: "#",
      //         image_path: "mypage_follow.png",
      //         word: "マイページ"
      //     },
      //     {
      //         link: "review",
      //         image_path: "menu_icon3.png",
      //         word: "クチコミを探す"
      //     },
      //     {
      //         link: "user",
      //         image_path: "menu_icon4.png",
      //         word: "ユーザーを探す"
      //     },
      //     {
      //         link: "bbs",
      //         image_path: "menu_icon5.png",
      //         word: "掲示板を探す"
      //     },
      //     {
      //         link: "#",
      //         image_path: "menu_icon6.png",
      //         word: "記事を探す"
      //     },
      //     {
      //         link: "#",
      //         image_path: "menu_icon7.png",
      //         word: "式場を探す"
      //     },
      //     {
      //         link: "tag",
      //         image_path: "menu_icon9.png",
      //         word: "タグから探す"
      //     }
      // ],
      // logoutMainMenus: [{
      //         link: "#",
      //         image_path: "menu_icon1.png",
      //         word: "結婚式準備.comとは？"
      //     },
      //     {
      //         link: "user/sign_in",
      //         image_path: "menu_icon2.png",
      //         word: "新規会員登録・ログイン"
      //     },
      //     {
      //         link: "review",
      //         image_path: "menu_icon3.png",
      //         word: "クチコミを探す"
      //     },
      //     {
      //         link: "user",
      //         image_path: "menu_icon4.png",
      //         word: "ユーザーを探す"
      //     },
      //     {
      //         link: "bbs",
      //         image_path: "menu_icon5.png",
      //         word: "掲示板を探す"
      //     },
      //     {
      //         link: "#",
      //         image_path: "menu_icon6.png",
      //         word: "記事を探す"
      //     },
      //     {
      //         link: "#",
      //         image_path: "menu_icon7.png",
      //         word: "式場を探す"
      //     },
      //     {
      //         link: "#",
      //         image_path: "menu_icon9.png",
      //         word: "タグから探す"
      //     }
      // ]
    };
  },
  created() {},
  methods: {
    //ハンバーガーメニューの表示・非表示
    toggleMenu() {
      var bg = document.getElementById("menu_background");
      var wrapper = document.getElementById("menu_list_wrapper");
      // var main = document.getElementsByTagName("main")[0];
      // var footer = document.getElementsByTagName("footer")[0];

      if (!bg.classList.contains("background_open")) {
        this.offset = window.pageYOffset;
        // main.style.top = -this.offset + "px";
        // footer.style.top = -(this.offset - main.scrollHeight) + "px";
        bg.style.display = "block";
        wrapper.style.display = "block";
        wrapper.style.height = "100vh";
        wrapper.style.overflowY = "scroll";
        // main.style.position = "fixed";
        // footer.style.position = "fixed";

        // 開くアニメーションのため時間差実行
        setTimeout(function () {
          bg.classList.add("background_open");
          wrapper.classList.add("list_open");
          //                    this.open = true; // 時間差実行だとvueのopen変数が何故かtrueとならないため不採用
        }, 1);
      } else {
        bg.classList.remove("background_open");
        wrapper.classList.remove("list_open");
        bg.style.display = "none";
        wrapper.style.display = "none";
        // main.style.position = "static";
        // footer.style.position = "static";
        document.documentElement.scrollTop = this.offset;
        //                this.open = false
      }
      this.showDrawering = [];
    },
    mouseOverMenu(menu) {
      this.hoverMenu = menu;
    },
    mouseLeaveMenu() {
      this.hoverMenu = null;
    },
    toggleDrawer(drawerIndex) {
      if (this.showDrawering.includes(drawerIndex)) {
        this.showDrawering = this.showDrawering.filter((i) => i != drawerIndex);
      } else {
        this.showDrawering.push(drawerIndex);
      }
    },
  },
  computed: {
    isLogin() {
      return this.$store.getters["auth/check"];
    },
    userid() {
      return this.$store.getters["auth/userid"];
    },
    communicationUrl: function () {
      return process.env.VUE_APP_BASE_COMMUNICATION_URL;
    },
    mediaportalUrl: function () {
      return process.env.VUE_APP_BASE_MEDIAPORTAL_URL;
    },
    mediaportalResourceUrl: function () {
      return (
        process.env.VUE_APP_BASE_MEDIAPORTAL_URL +
        process.env.VUE_APP_MEDIAPORTAL_RESOURCE_URI
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Humberger.vue